
import { Inject, Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { DomainObjectRepo } from '../../noizu/domain-object-repo';
import { FirebaseAuthService }        from '../../noizu/services/firebase-auth.service';
import { FirmwareLinkEntity }      from '../../entities/firmware/link.entity';
import { AppengineRepo }      from '../appengine.repo';

@Injectable()
export class FirmwareLinkRepo extends AppengineRepo {
  public _kind = "firmware-links";
  public _singular = "firmware-links";

  constructor(@Inject(HttpClient) client: HttpClient, @Inject(FirebaseAuthService) auth: FirebaseAuthService) {
    super(client, auth);
  }

  entity(record) {
    return new FirmwareLinkEntity(this.client, this.auth, record)
  }
}
